export enum PosStatus {
  Opened = 'opened',
  Closed = 'closed',
}
